import { Component, Input } from '@angular/core';

@Component({
  selector: 'employee-circle-display',
  templateUrl: './employee-circle-display.component.html',
  styleUrls: ['./employee-circle-display.component.scss']
})
export class EmployeeCircleDisplayComponent {
  @Input()
  firstName: string;
  @Input()
  lastName: string;
  @Input()
  profilePicture: AssetUuidObject;
}

class AssetUuidObject {
  uuid: string;
}
